




























































































































































import {
	defineComponent,
	onMounted,
	Ref,
	reactive,
	toRefs,
	computed,
	ref,
	PropType,
	ComputedRef,
} from '@vue/composition-api';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { GroupStatsStore } from '@front-app/store/singletons/GroupStats';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { useAsyncStatusDeprecated, useIsLoading } from '@front-app/hooks/useAsyncStatus';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import SelectButton from '@front-app/components/buttons/SelectButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import GroupCard from '@front-app/components/cards/GroupCard.vue';
import { ButtonNavButton } from '@front-app/components/buttons/buttonNav';
import ButtonNav from '@front-app/components/buttons/ButtonNav.vue';
import {
	Group,
	Groups,
} from '@front-app/services/GroupsApi/GroupModel';
import {
	isAdminRole,
	isInviteeRole,
	isMemberRole,
	areDiscussionsVisibleForCurrentUser,
	isCsr,
	hasAdminPrivileges,
} from '@front-app/util/permission';
import {
	sortGroupByLastVisit,
	sortGroupByAlphabetical,
} from '@front-app/modules/group/util/sort';
import { EnumMap } from '@front-app/util/enum';
import { useFilter } from '@front-app/hooks/useFilter';
import { GroupListQuery } from '@front-app/router/util/groupListQuery';
import { STATUS } from '@front-app/constants/state';
import { PageProgress } from '@front-app/store/singletons/PageProgress';
import { fromWeightedPromises } from '@front-app/store/modules/progressBar';
import { useRouteQueryArray } from '@front-app/hooks/useRouteQueryArray';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import SearchBox from '@front-app/components/search/SearchBox.vue';
import SearchPlaceholder from '@front-app/components/search/SearchPlaceholder.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import RoleBadge from '@front-app/components/cards/RoleBadge.vue';
import { useDiscussionModal } from '@front-app/components/discussion/useDiscussionModal';
import { useGroupMembershipRole } from '@front-app/hooks/useMembershipRole';
import { Size } from '@front-app/components/constants';
import RadioList from '@front-app/components/inputs/RadioList.vue';
import { SelectBoxChoice } from '@front-app/components/inputs/SelectBoxModel';
import CheckboxList from '@front-app/components/inputs/CheckboxList.vue';
import { FontAwesomeIconProps, SORT_BY_ALPH_ASC_ICON, SORT_BY_DATE_ICON } from '@front-app/vendor/icon-definitions';
import GroupsSummary from './groups/GroupsSummary.vue';
import {
	DEFAULT_GROUP_FILTERS,
	GroupFilter,
	GroupSort,
	sortButtonLabels,
} from './groups/GroupEnum';
import { useSelectAdminGroups } from './groups/useSelectAdminGroups';

type FilteredGroups = {
	[k in GroupFilter]: Ref<Groups>;
}

const SORT_TO_SORTER: EnumMap<GroupSort, (a: Group, b: Group) => number> = {
	[GroupSort.LAST_VISIT]: sortGroupByLastVisit,
	[GroupSort.ALPHABETICAL]: sortGroupByAlphabetical,
};

const SORT_TO_ICON: EnumMap<GroupSort, FontAwesomeIconProps> = {
	[GroupSort.ALPHABETICAL]: SORT_BY_ALPH_ASC_ICON,
	[GroupSort.LAST_VISIT]: SORT_BY_DATE_ICON,
};

// Defines the order in which the filter buttons appear in the UI
const FILTER_BUTTON_ORDER = [
	GroupFilter.ADMINISTERED,
	GroupFilter.INVITES,
	GroupFilter.MEMBER,
];

const FILTER_TO_USER_ROLE = {
	[GroupFilter.ADMINISTERED]: UserRole.ADMINISTRATOR,
	[GroupFilter.INVITES]: UserRole.INVITEE,
	[GroupFilter.MEMBER]: UserRole.MEMBER,
};

export function groupRole(fn: (r: UserRole) => boolean): (g: Group) => boolean {
	return (group: Group) => fn(group.role);
}

export default defineComponent({
	components: {
		// Layout
		GroupsSummary,
		ColumnHeader,
		ColumnContainer,
		PaddedContent,
		ScrollingColumn,
		SlidingPanel,
		// Form Controls
		RadioList,
		CheckboxList,
		TrCheckbox,
		ButtonNav,
		SelectButton,
		SearchBox,
		SearchPlaceholder,
		// Uitl
		CtaButton,
		LoaderState,
		FontAwesomeIcon,
		// Group
		GroupCard,
		RoleBadge,
	},
	props: {
		currentAccessFilters: {
			type: Array as PropType<GroupFilter[]>,
			default: DEFAULT_GROUP_FILTERS,
		},
		currentSort: {
			type: String as PropType<GroupSort>,
			default: GroupSort.ALPHABETICAL,
		},
	},
	setup(props, ctx) {
		// Page loading
		const groupsStore = GroupsStore.getInstance();
		const fetchGroups = groupsStore.fetchGroupsOnce();
		const fetchStats = fetchGroups
			.then(() => GroupStatsStore.getInstance().getStats(groupsStore.groups.value.map(({ id }) => id)));
		const isGroupFetching = useIsLoading(useAsyncStatusDeprecated(fetchGroups));
		const areStatsFetching = useIsLoading(useAsyncStatusDeprecated(fetchStats));

		PageProgress.setProgress(fromWeightedPromises([
			{
				promise: fetchGroups,
				weight: 70,
			},
			{
				promise: fetchStats,
				weight: 30,
			},
		]).progress);
		// END page loading

		// Responsive view
		const screenWidth = ref(window.innerWidth);
		onMounted(() => {
			window.onresize = () => {
				screenWidth.value = window.innerWidth;
			};
		});
		// eslint-disable-next-line arrow-body-style
		const getGroupCardSize = () => {
			return screenWidth.value < 810 ? Size.MEDIUM : Size.LARGE;
		};
		// END Responsive view

		const state = reactive({
			areAllVisibleGroupsChecked: false,
		});

		// Group list filtering and sorting
		const checkedAdminGroups = useSelectAdminGroups(groupsStore.groups, CurrentUserStore.isCsr);
		const availableAccessFilters = computed(() => props.currentAccessFilters
			.filter((key) => key !== GroupFilter.ADMINISTERED || checkedAdminGroups.hasAdministerableGroups.value));
		const searchValue = ref('');
		const searchedGroups = useFilter(groupsStore.groups, (g: Group) => g.name.toLocaleLowerCase().includes(searchValue.value.toLocaleLowerCase()));

		const filteredGroups: FilteredGroups = {
			[GroupFilter.ADMINISTERED]: useFilter(searchedGroups, groupRole(isAdminRole)),
			[GroupFilter.INVITES]: useFilter(searchedGroups, groupRole(isInviteeRole)),
			[GroupFilter.MEMBER]: useFilter(searchedGroups, groupRole(isMemberRole)),
		};
		const groupsInvitedTo = computed(() => filteredGroups[GroupFilter.INVITES].value);
		const sortedGroupList = computed(() => availableAccessFilters.value
			.flatMap((filterKey) => filteredGroups[filterKey].value)
			.sort(SORT_TO_SORTER[props.currentSort]));

		const toSort = (sort: GroupSort) => ({ ...ctx.root.$route, query: { ...ctx.root.$route.query, [GroupListQuery.SORT]: sort } });

		const sortButtonList: Ref<ButtonNavButton[]> = computed(() => Object.values(GroupSort)
			.map((key) => ({
				key,
				label: ctx.root.$t(sortButtonLabels[key]) as unknown as string,
			}))) as ComputedRef<ButtonNavButton[]>;

		const accessFilterUrlQuery = useRouteQueryArray(ctx.root.$router, computed(() => ctx.root.$route), GroupListQuery.FILTERS, computed(() => availableAccessFilters.value));

		const goToAccessFilter = (key: GroupFilter) => {
			if (availableAccessFilters.value.includes(key)) {
				accessFilterUrlQuery.removeVisit(key);
			} else {
				accessFilterUrlQuery.appendVisit(key);
			}
		};

		const goToInvitesFilter = () => {
			const q = ctx.root.$route.query;
			ctx.root.$router.push({ query: { ...q, [GroupListQuery.FILTERS]: GroupFilter.INVITES } });
		};

		const filterKeyToNavData = (key: GroupFilter): SelectBoxChoice => {
			const count = filteredGroups[key].value.length;
			const label = ctx.root.$n(count) as string;
			return {
				key,
				label,
				disabled: count === 0,
			};
		};

		const filterButtonList: Ref<SelectBoxChoice[]> = computed(() => FILTER_BUTTON_ORDER
			// We should hide the administered button for non-admins (the only way to know if a user is admin)
			// is if they have any administered groups
			.filter((key) => key !== GroupFilter.ADMINISTERED || checkedAdminGroups.hasAdministerableGroups.value)
			.map(filterKeyToNavData));

		const userRolesForFilter = (key: GroupFilter) => useGroupMembershipRole(FILTER_TO_USER_ROLE[key]);
		const currentFilterCount = computed(() => sortedGroupList.value.length);
		// END group list filtering

		// Group Counts
		const numGroups = computed(() => groupsStore.groups.value.length);
		const numVisibleAdministeredGroups = computed(() => sortedGroupList.value
			.filter((g: Group) => hasAdminPrivileges(g.role, CurrentUserStore.isCsr.value))
			.length);
		// END Counts

		// Analytics
		const onToggleCheck = (group: Group): void => {
			if (checkedAdminGroups.isGroupChecked(group)) {
				checkedAdminGroups.removeGroup(group);
			} else {
				checkedAdminGroups.addGroup(group);
			}
		};
		const checkedGroups = computed(() => sortedGroupList
			.value
			.filter(checkedAdminGroups.isGroupChecked));
		const areAnalyticsVisible = computed(() => checkedGroups.value.length > 0);
		const selectAll = () => {
			state.areAllVisibleGroupsChecked = !state.areAllVisibleGroupsChecked;
			if (state.areAllVisibleGroupsChecked) {
				checkedAdminGroups.setGroups(sortedGroupList.value);
			} else {
				checkedAdminGroups.clearAll();
			}
		};
		// END Analytics

		// Discussion things
		const {
			isDiscussionModalVisible,
			discussionModalView,
			showDiscussionModal,
			closeDiscussionModal,
		} = useDiscussionModal('groupSummaryStartDiscussionButton');

		const areAnyCheckedGroupsDiscussable = computed(() => checkedGroups
			.value
			.some((group: Group) => areDiscussionsVisibleForCurrentUser(group, CurrentUserStore.isCsr.value)));
		// END Discussion things

		const hasAdministerableGroups = computed(() => (availableAccessFilters.value.includes(GroupFilter.ADMINISTERED))
			|| isCsr(CurrentUserStore.currentUser.value));

		return {
			...toRefs(state),
			numGroups,
			numVisibleAdministeredGroups,
			hasAdministerableGroups,
			isGroupChecked: checkedAdminGroups.isGroupChecked,
			userRolesForFilter,
			filterKeyToNavData,
			filterButtonList,
			GroupFilter,
			availableAccessFilters,
			goToAccessFilter,
			groupsInvitedTo,
			goToInvitesFilter,
			sortButtonList,
			currentFilterCount,
			SORT_TO_ICON,
			toSort,
			allGroups: groupsStore.groups,
			sortedGroupList,
			isGroupFetching,
			areStatsFetching,
			loadingStatus: STATUS.LOADING,
			// Discussions
			isDiscussionModalVisible,
			discussionModalView,
			showDiscussionModal,
			closeDiscussionModal,
			areAnyCheckedGroupsDiscussable,
			// Analytics
			areAnalyticsVisible,
			checkedGroups,
			onToggleCheck,
			selectAll,
			// Search
			searchValue,
			// Util
			ButtonPalettes,
			getGroupCardSize,
			Size,
		};
	},
});
